import {inject, Injectable, resource} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {environment} from "../../../environments/environment";
import {HomeyConfigDto} from "homey-housing-lottery-app-dto";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly http = inject(HttpClient);

  private readonly configResource = resource<HomeyConfigDto, void>({
    loader: () => firstValueFrom(
      this.http.get<HomeyConfigDto>(`${environment.apiUrl}/api/public/config`)
    )
  });

  readonly nycAccountAccessEnabled = () => this.configResource.value()?.nycAccountAccessEnabled ?? true;
}
